import Error404 from "@/components/404";
import Footer from "@/components/Footer";
import Header from "@/components/Header";
import MobileBottomNav from '@/components/MobileBottomNav';

export default function NotFound() {
    return <>
        <Header />
        <Error404 />
        <Footer hasMobileNav />
        <MobileBottomNav />
    </>;
}
